const holder = {
  closeDateRangeSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeDateRangeSelector)
    }
  }
};

export default {
  refreshOn: ({ selectedDate }) => ([selectedDate]),
  'DatePicker.Selector.Input(Keydown)': ({ entryVal, key }, outlet, internalStateSetter) => {
    if (key === 'Enter') {
      const parsedDate = new Date(entryVal)

      if (parsedDate.valueOf()) {
        internalStateSetter({ entryVal: null, selectedDate: parsedDate, isOpen: false })
        outlet({ selectedDate: parsedDate })
      } else {
        internalStateSetter({ entryVal: null })
      }
    }
  },
  'DatePicker.Selector.Input': ({ value }, _, internalStateSetter) => {
    internalStateSetter('entryVal', value);
  },
  'DatePicker.Selector': ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter
    holder.containerRef = containerRef
    internalStateSetter({ isOpen: !isOpen });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDateRangeSelector);
    } else {
      document.addEventListener("mousedown", holder.closeDateRangeSelector);
    }
  },
  'DatePicker.CalendarOuterWrapper.CalendarWrapper.Calendar': ({ selectedDate }, outlet, internalStateSetter) => {
    internalStateSetter({ selectedDate, isOpen: false })
    outlet({ selectedDate })
  }
}